// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

var tooltipPanelClass = "fixed px-2.5 py-1 rounded-md text-xs font-medium bg-elevation-2 text-foreground border border-stroke-subtle shadow-lg pointer-events-none z-tooltip min-w-[12rem] max-w-[20rem] w-max text-left leading-snug transition-opacity duration-150";

function parseTooltipPosition(raw) {
  switch (raw) {
    case "bottom" :
        return "bottom";
    case "left" :
        return "left";
    case "right" :
        return "right";
    default:
      return "top";
  }
}

function floatPx(value) {
  return value.toString() + "px";
}

function computeTooltipStyle(position, rect, pad) {
  if (position === "bottom") {
    return {
            left: floatPx(rect.left + rect.width / 2.0),
            top: floatPx(rect.bottom + pad),
            transform: "translate(-50%, 0)"
          };
  } else if (position === "right") {
    return {
            left: floatPx(rect.right + pad),
            top: floatPx(rect.top + rect.height / 2.0),
            transform: "translate(0, -50%)"
          };
  } else if (position === "top") {
    return {
            left: floatPx(rect.left + rect.width / 2.0),
            top: floatPx(rect.top - pad),
            transform: "translate(-50%, -100%)"
          };
  } else {
    return {
            left: floatPx(rect.left - pad),
            top: floatPx(rect.top + rect.height / 2.0),
            transform: "translate(-100%, -50%)"
          };
  }
}

function applyTooltipStyle(tip, styles) {
  var tipStyle = tip.style;
  tipStyle.position = "fixed";
  tipStyle.zIndex = String(100002);
  tipStyle.left = styles.left;
  tipStyle.top = styles.top;
  tipStyle.transform = styles.transform;
}

function showTooltip(tip) {
  var tipStyle = tip.style;
  tipStyle.opacity = "1";
  tipStyle.visibility = "visible";
}

function hideTooltip(tip) {
  var tipStyle = tip.style;
  tipStyle.opacity = "0";
  tipStyle.visibility = "hidden";
}

function mounted() {
  var self = this ;
  var element = self.el;
  self.scrollParent = Caml_option.nullable_to_opt(element.closest("[data-snippets-scroll-container]"));
  var tip = document.createElement("div");
  tip.className = tooltipPanelClass;
  hideTooltip(tip);
  tip.style.zIndex = String(100002);
  tip.style.position = "fixed";
  document.body.appendChild(tip);
  self.tooltipEl = Caml_option.some(tip);
  var onEnter = function (_event) {
    var tipEl = self.tooltipEl;
    if (tipEl === undefined) {
      return ;
    }
    var tipEl$1 = Caml_option.valFromOption(tipEl);
    var rect = element.getBoundingClientRect();
    var position = parseTooltipPosition(Belt_Option.getWithDefault(Caml_option.nullable_to_opt(element.getAttribute("data-tooltip-position")), "top"));
    var raw = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(element.getAttribute("data-tooltip-tip")), "");
    tipEl$1.textContent = raw;
    applyTooltipStyle(tipEl$1, computeTooltipStyle(position, rect, 6.0));
    showTooltip(tipEl$1);
  };
  var onLeave = function (_event) {
    var tipEl = self.tooltipEl;
    if (tipEl !== undefined) {
      return hideTooltip(Caml_option.valFromOption(tipEl));
    }
    
  };
  var onScroll = function (_event) {
    onLeave(_event);
  };
  self.onEnter = onEnter;
  self.onLeave = onLeave;
  self.onScroll = onScroll;
  element.addEventListener("pointerenter", onEnter);
  element.addEventListener("pointerleave", onLeave);
  var parent = self.scrollParent;
  if (parent !== undefined) {
    Caml_option.valFromOption(parent).addEventListener("scroll", onScroll, {
          passive: true
        });
    return ;
  }
  
}

function updated() {
  var self = this ;
  var tip = self.tooltipEl;
  if (tip !== undefined) {
    Caml_option.valFromOption(tip).textContent = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(self.el.getAttribute("data-tooltip-tip")), "");
    return ;
  }
  
}

function destroyed() {
  var self = this ;
  var element = self.el;
  element.removeEventListener("pointerenter", self.onEnter);
  element.removeEventListener("pointerleave", self.onLeave);
  var parent = self.scrollParent;
  if (parent !== undefined) {
    Caml_option.valFromOption(parent).removeEventListener("scroll", self.onScroll);
  }
  var tip = self.tooltipEl;
  if (tip !== undefined) {
    Caml_option.valFromOption(tip).remove();
  }
  self.tooltipEl = undefined;
}

var tooltipEscapeClip = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var tooltipOffsetPx = 6.0;

var tooltipZIndex = 100002;

export {
  tooltipOffsetPx ,
  tooltipZIndex ,
  tooltipPanelClass ,
  parseTooltipPosition ,
  floatPx ,
  computeTooltipStyle ,
  applyTooltipStyle ,
  showTooltip ,
  hideTooltip ,
  mounted ,
  updated ,
  destroyed ,
  tooltipEscapeClip ,
}
/* mounted Not a pure module */
